import { render, staticRenderFns } from "./ProductAdvancedFilters.vue?vue&type=template&id=6fa352d1"
import script from "./ProductAdvancedFilters.vue?vue&type=script&lang=js"
export * from "./ProductAdvancedFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports